var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SelectionButtonIcons from './SelectionButtonIcons';
import SelectionButtonSelectionContent from './SelectionButtonContent';
import { DEFAULT_SELECTION_PLACEHOLDER } from './constants';
import StyledSelectionButton, { CustomBottomText, } from './StyledSelectionButton';
// eslint-disable-next-line complexity
const SelectionButton = (_a) => {
    var { selection = DEFAULT_SELECTION_PLACEHOLDER, ariaLabel, isEnhanced, isSuperOdds, isFlashOdds, isDoubleYourOdds, customIcon, customText, customTextBottom, hideName, hideIcon, isAlwaysOnFlashOdds, expanded, size, callback } = _a, restButtonProps = __rest(_a, ["selection", "ariaLabel", "isEnhanced", "isSuperOdds", "isFlashOdds", "isDoubleYourOdds", "customIcon", "customText", "customTextBottom", "hideName", "hideIcon", "isAlwaysOnFlashOdds", "expanded", "size", "callback"]);
    const isChangingSelection = selection.isAdding ||
        selection.isRemoving ||
        selection.isProcessing ||
        selection.isGoal;
    return (React.createElement(StyledSelectionButton, Object.assign({ type: "button", onClick: () => {
            if (selection.onClick) {
                selection.onClick();
            }
            if (callback) {
                callback();
            }
        }, disabled: selection.isSuspended || selection.isProcessing, "aria-label": ariaLabel || selection.name, "aria-pressed": selection.isAdded, "data-testid": `SelectionButton.${selection.selectionId || selection.id}`, selection: selection, isEnhanced: isEnhanced, isSuperOdds: isSuperOdds, isFlashOdds: isFlashOdds, isDoubleYourOdds: isDoubleYourOdds, isAlwaysOnFlashOdds: isAlwaysOnFlashOdds, expanded: expanded, size: size }, restButtonProps),
        !isChangingSelection && !hideIcon && (React.createElement(SelectionButtonIcons, { isEnhanced: isEnhanced, isSuperOdds: isSuperOdds, isFlashOdds: isFlashOdds, isDoubleYourOdds: isDoubleYourOdds, customIcon: customIcon })),
        !isChangingSelection && customText && React.createElement("span", null, customText),
        React.createElement(SelectionButtonSelectionContent, { selection: selection, hideName: hideName }),
        !isChangingSelection && customTextBottom && (React.createElement(CustomBottomText, null,
            " ",
            customTextBottom))));
};
export default SelectionButton;
